var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 460,
    height: 279,
    viewBox: "0 0 460 279",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M258.753 278.427L186.261 278.427L168.95 180.869C165.583 161.995 163.059 145.645 161.376 131.82C160.534 124.968 159.813 119.257 159.212 114.689C158.611 110.121 158.19 106.634 157.95 104.23C157.348 109.159 156.447 118.356 155.245 131.82C154.644 138.673 153.922 145.886 153.081 153.459C152.239 161.033 151.217 169.028 150.015 177.443L135.769 278.427H62.5562L0.523438 0.000488281L74.8185 0.000488281L87.0808 76.6398C91.7693 107.175 95.0152 131.159 96.8185 148.591L99.343 174.017L101.687 152.197C104.212 126.711 107.458 102.487 111.425 79.525L125.491 0.000488281L190.228 0.000488281L202.851 66.9021C208.862 98.0387 214.092 134.886 218.54 177.443C219.862 158.328 221.305 141.377 222.868 126.591C224.43 111.804 226.174 98.3993 228.097 86.3775L241.802 0.000488281L315.195 0.000488281L258.753 278.427Z",
    fill: "#FDBB11"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M320.079 278.427L320.079 0.000488281L459.833 0.000488281V65.4595L395.275 65.4595V106.033L453.161 106.033V168.968H395.275V211.525H459.833L459.833 278.427H320.079Z",
    fill: "#FDBB11"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWe);
export default __webpack_public_path__ + "static/media/we.d139881e5e51f36a24d10dee1b8b8913.svg";
export { ForwardRef as ReactComponent };